import React from "react";
import { PersonInfo } from "../../../models/customer.model";
import BorderedLayout from "../../../layouts/BorderedLayout";
import { Grid, Typography } from "@mui/material";

interface Props {
  personInfo: PersonInfo;
}

const CustomerHeader = ({ personInfo }: Props) => {
  return (
    <div>
      <BorderedLayout
        title={
          <Typography
            sx={{
              color: "#1D4A87",
              fontSize: "1.1rem",
              fontWeight: "bold",
            }}
          >
            مشخصات متقاضی
          </Typography>
        }
        backgroundColor="#F9FAFC"
      >
        <Grid container sx={{ padding: "20px" }} gap={"20px"}>
          {/* top section */}
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={3}>
                <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
                  نام و نام خانوادگی:{" "}
                  <span style={{ color: "#34495E" }}>
                    {personInfo?.customerFullName}
                  </span>
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
                  کد ملی:{" "}
                  <span style={{ color: "#34495E" }}>
                    {personInfo?.customerNationalCode}
                  </span>
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
                  شماره شناسنامه:{" "}
                  <span style={{ color: "#34495E" }}>
                    {personInfo?.customerShenasnamehNumber}
                  </span>
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
                  تاریخ تولد:{" "}
                  <span style={{ color: "#34495E" }}>
                    {personInfo?.customerBirthDatePersian}
                  </span>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          {/* middle section  */}
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={3}>
                <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
                  نام پدر:{" "}
                  <span style={{ color: "#34495E" }}>
                    {personInfo?.customerFatherName}
                  </span>
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
                  سری/سریال شناسنامه:{" "}
                  <span style={{ color: "#34495E" }}>
                    {`${personInfo?.customerSerialNumber} / ${personInfo?.customerSeriNumber}`}
                  </span>
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
                  شماره همراه:{" "}
                  <span style={{ color: "#34495E" }}>
                    {personInfo?.customerMobileNumber}
                  </span>
                </Typography>
              </Grid>
              <Grid item xs={3}></Grid>
            </Grid>
          </Grid>
          {/* description section */}
          {personInfo?.customerAddresses.length > 0 && (
            <Grid
              item
              xs={12}
              sx={{
                borderTop: "1px solid #C1C7CB",
                paddingTop: "20px",
                display: "flex",
                flexDirection: "column",
                gap: "15px",
              }}
            >
              <Typography
                sx={{
                  color: "#1D4A87",
                  fontSize: "1.1rem",
                  fontWeight: "bold",
                }}
              >
                مشخصات سکونتی
              </Typography>
              {personInfo?.customerAddresses.map((address, index) => (
                <Typography
                  key={index}
                  sx={{ color: "#9AAFC4", fontSize: "1rem" }}
                >
                  آدرس/کدپستی:{" "}
                  <span
                    style={{ color: "#34495E" }}
                  >{`${address?.address} / ${address?.postalCode}`}</span>
                </Typography>
              ))}
            </Grid>
          )}
        </Grid>
      </BorderedLayout>
    </div>
  );
};

export default CustomerHeader;
